export const setupSections = [
  {
    id: 'pc-principal',
    title: 'PC Principal',
    items: [
      { label: 'CPU', value: 'AMD Ryzen 7 7800X3D 8-Core (4.2GHz-5.0GHz)' },
      { label: 'GPU', value: 'NVIDIA RTX 4070 OC 12GB' },
      { label: 'RAM', value: 'Corsair 32GB (2 x 16GB) DDR5 6400MHz' },
      { label: 'Armazenamento', value: 'SSD Western Digital Black SN770 1TB' },
      { label: 'Motherboard', value: 'Asus PRIME B650-Plus' },
    ],
  },
  {
    id: 'perifericos',
    title: 'Periféricos',
    items: [
      { label: 'Monitor', value: 'ZOWIE XL2540K 24.5" FullHD 240Hz FreeSync Premium' },
      { label: 'Monitor Secundário', value: 'Asus VG248QE 144Hz 1ms 24"' },
      { label: 'Teclado', value: 'Razer Hunstman V3 Pro TKL' },
      { label: 'Rato', value: 'Razer Viper v3 pro' },
      { label: 'Headset', value: 'HyperX Cloud III Wireless' },
    ],
  },
  {
    id: 'stream-audio',
    title: 'Streaming & Áudio',
    items: [
      { label: 'Microfone', value: 'Depende dos dias' },
      { label: 'Câmara', value: 'Uma batata' },
    ],
  },
  {
    id: 'outros',
    title: 'Outros',
    items: [
      { label: 'Cadeira', value: 'Uma da sala' },
      { label: 'Secretária', value: 'Mesa da Cozinha' },
      { label: 'Internet', value: 'Fraca' },
    ],
  },
];
